import axios from 'axios';
import { req } from './axiosFun';

/**
 * 景点管理
 **/
// 获取景点列表
export const campList = (params) => { return axios.get("/customer/listMust") };
export const campListSave  = (params) => { return req("post", "/customer/addMust", params) };
export const campListDel  = (params) => { return req("post", "/customer/deleteMust", params) };






// WEBPACK FOOTER //
// ./src/api/campsMG9.js